import { PageHeader } from '@/components/page-header';
import { mustChangePassword } from '@/features/auth/guards';
import { useSession } from '@/features/auth/session';
import { AccessSection, AppearanceSection, PasswordSection, SessionsSection } from '../sections';

/** "Minha conta": dados de acesso do próprio usuário. Qualquer usuário autenticado, sem permissão especial. */
export function AccountPage() {
  const { me } = useSession();
  return (
    <>
      {mustChangePassword(me) && <MustChangePasswordBanner />}
      <PageHeader title="Minha conta" description="Seus dados de acesso, senha e dispositivos conectados." />
      <div className="grid items-start gap-6 xl:grid-cols-2">
        <div className="flex min-w-0 flex-col gap-6">
          <AccessSection />
          <PasswordSection />
        </div>
        <div className="flex min-w-0 flex-col gap-6">
          <SessionsSection />
          <AppearanceSection />
        </div>
      </div>
    </>
  );
}

/** Faixa exibida enquanto a senha definida pelo operador não foi trocada. */
export function MustChangePasswordBanner() {
  return (
    <p role="alert" className="mb-5 rounded-control border border-warning/40 bg-warning/10 px-4 py-3 text-sm font-medium">
      Defina uma nova senha para continuar. A senha atual foi definida por um administrador da plataforma.
    </p>
  );
}
